import React, { FC } from "react";
import classNames from "classnames/dedupe";
import { HeartRedIcon } from "../../../icons";
import noop from "../../../helpers/noop";
import { SvgIcon } from "../../Icons";

export interface IWishlistButtonProps {
  /**
   * Set if item in wishlist
   */
  isFavorite?: boolean;
  isAnimating?: boolean;
  /**
   * Callback function on when "wishlist" status has changed
   */
  onClick?: (event) => void;
  onAnimation?: (state: IWishlistButtonProps["isAnimating"]) => void;
}

const WishlistButton: FC<IWishlistButtonProps> = ({
  isAnimating,
  isFavorite,
  onAnimation = noop,
  onClick = noop,
}) => {
  const handleAnimationEnd = () => onAnimation(false);
  const handleAnimationStart = () => onAnimation(true);

  return (
    <div
      className={classNames("favorite", {
        "favorite--active": isAnimating || isFavorite,
      })}
      data-testid="Wishlist__TestID"
      onAnimationStart={handleAnimationStart}
      onTransitionEnd={handleAnimationEnd}
      onAnimationEnd={handleAnimationEnd}
      onClick={onClick}
    >
      <SvgIcon
        icon={HeartRedIcon}
        classes={{
          root: classNames("position-absolute start-0 top-0", {
            "uds-appear-scale-enter-active": isFavorite,
            "uds-zoom-animation": isAnimating,
          }),
        }}
      />
    </div>
  );
};

export default WishlistButton;
